import React from "react";

import { Helmet } from "react-helmet-async";

export const SEO = ({ title, description }: any) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};
